export type StripeAccountStatusData = {
  chargesEnabled?: boolean;
  payoutsEnabled?: boolean;
  detailsSubmitted?: boolean;
  disabledReason?: string | null;
  currentDeadline?: string | null;
  currentlyDue?: string[];
  pastDue?: string[];
  updatedAt?: string | null;
};

export type SellerWithStripeStatus = {
  paymentGateways?: {
    stripe?: {
      isActive?: boolean;
      userId?: string;
      accountStatus?: StripeAccountStatusData | null;
    };
  };
};

export type StripeAccountStatus =
  | 'rejected'
  | 'under_review'
  | 'restricted'
  | 'payouts_paused'
  | 'action_needed'
  | 'active';

export const STRIPE_ACCOUNT_STATUS_LABELS: Record<StripeAccountStatus, string> = {
  rejected: 'Rejected',
  under_review: 'Under review',
  restricted: 'Payments paused',
  payouts_paused: 'Payouts paused',
  action_needed: 'Details due',
  active: 'Active',
};

const REVIEW_REASONS = ['under_review', 'requirements.pending_verification'];

export default function getStripeAccountStatus(
  seller: SellerWithStripeStatus | null | undefined,
): StripeAccountStatus | null {
  const stripe = seller?.paymentGateways?.stripe;
  const accountStatus = stripe?.accountStatus;
  // Sellers connected before status syncing have none until Stripe sends an account.updated; don't guess.
  if (!stripe?.isActive || !accountStatus) return null;

  const { chargesEnabled, payoutsEnabled, disabledReason, currentlyDue, currentDeadline } =
    accountStatus;

  if (disabledReason?.startsWith('rejected.')) return 'rejected';
  if (!chargesEnabled && REVIEW_REASONS.includes(disabledReason ?? '')) return 'under_review';
  if (!chargesEnabled) return 'restricted';
  if (!payoutsEnabled) return 'payouts_paused';
  if (currentlyDue?.length && currentDeadline) return 'action_needed';
  return 'active';
}
